import React, { Fragment, useEffect, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import { AppContext } from "@component/AppProvider";
import parse, { domToReact } from "html-react-parser";
import swal from "sweetalert";
import moment from "moment";

import _API from "@util/api";
import _U from "@util/utilities";
import _DEF from "@config/defines";
import _CK from "@util/cookie";

import Editor from "@component/UI/TMEditor";

import Loading from "@component/UI/Loading";

export default () => {
    const navigate = useNavigate();
    const { site, iam } = useContext(AppContext);
    const [cfg, setCfg] = useState(null);

    const [memos, setMemos] = useState([]);
    const [options, setOptions] = useState(null);
    const [data, setData] = useState({});
    const [program, setProgram] = useState([]);
    const [isLoading, setIsLoading] = useState(true);

    const loadConfig = () => {
        _API.get({ path: "/site/registration/config" })
            .then((res) => {
                const { cfg, options, memos, amounts, reg } = res.data;
                if (!reg) {
                    navigate("/registration/regist");
                }
                setCfg(cfg);
                setOptions(options);
                setMemos(memos);
                setData({
                    ...reg,
                    paymentDeadline: moment().add("weeks", 2).format("YYYY-MM-DD"),
                    senderName: reg?.senderName || `${iam?.nameFirst} ${iam?.nameLast} (${reg?.registrationNo})`,
                    country: _DEF.getDefinedLabel(_DEF.COUNTRY, iam?.country),
                });
                if (reg?.program && reg?.program?.length > 0) {
                    setProgram(reg?.program);
                }
            })
            .catch((e) => {
                console.log(e);
                _API.alert({ message: e.messages || JSON.stringify(e) });
            });
    };

    useEffect(() => {
        if (site?.siteCode && iam) {
            loadConfig();
        }
    }, [site?.siteCode, iam]);

    const getMemo = (type, field) => {
        let memo = memos?.find((m) => m.type === type);

        if (!memo?.[field]) {
            return "";
        }
        if (field === "title") {
            return memo?.[field];
        } else {
            return <div dangerouslySetInnerHTML={{ __html: memo?.[field]?.replace(/\\/g, "") }}></div>;
        }
    };

    const onBack = () => {
        if (cfg?.isUseOptionProgram !== "Y" && cfg?.isUseSpecialDietary !== "Y") {
            navigate("/registration/regist");
        } else {
            navigate("/registration/regist/step2");
        }
    };

    const getProgramPrice = (item) => {
        let price = 0;

        if (data?.amountType === "EARLY") {
            price = iam?.country === "KR" ? item.earlyWonAmount : item.earlyUsdAmount;
        }
        if (data?.amountType === "PRE") {
            price = iam?.country === "KR" ? item.preWonAmount : item.preUsdAmount;
        }
        if (data?.amountType === "LATE") {
            price = iam?.country === "KR" ? item.lateWonAmount : item.lateUsdAmount;
        }

        return price || 0;
    };

    const getProgramStatus = (item) => {
        if (data?.program && data?.program?.length > 0) {
            const select = data?.program?.find((p) => p.programIdx === item.idx);
            return select?.value === "Y" ? "Yes" : "No";
        }

        return "No";
    };

    const isIdCard = () => {
        return data?.isIdCard === "Y";
    };

    const onDataChange = (e) => {
        setData({ ...data, [e.target.name]: e.target.value });
    };

    if (!_CK.isLogin()) {
        swal("Please Login first.").then(() => {
            document.location.href = "/";
        });

        return;
    }

    return (
        <Fragment>
            <div className="contents">
                {site?.naviMypageRegistration && parse(site?.naviMypageRegistration)}

                <div className="right">
                    <div className="contentsTop">
                        <h3>Registration status</h3>
                        <div className="location">
                            <a href="/" className="home">
                                home
                            </a>
                            <div className="loc_txt">
                                <span>Registration status</span>
                            </div>
                        </div>
                    </div>
                    <div className="contWrap">
                        <h4 className="title">Registration Status and Payment</h4>

                        <div className="boxTable">
                            <table className="online_reg_step01">
                                <thead>
                                    <tr>
                                        <th colspan="2">Attendee’s Personal Information</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td width="50%" className="tit">
                                            Registration No
                                        </td>
                                        <td width="50%">{data?.registrationNo}</td>
                                    </tr>
                                    <tr>
                                        <td className="tit">Full Name</td>
                                        <td>
                                            {iam?.nameFirst} {iam?.nameLast}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div className="boxTable">
                            <table className="online_reg_step01">
                                <thead>
                                    <tr>
                                        <th colspan="3">Fee Details</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr>
                                        <td className="tit" width="50%">
                                            Category
                                        </td>
                                        <td width="25%">{data?.categoryName}</td>
                                        <td width="25%">
                                            {iam?.country !== "KR" && `USD `}
                                            {_U.addComma(data?.amount)}
                                            {iam?.country === "KR" && ` 원`}
                                        </td>
                                    </tr>
                                    {options?.map((item, index) => (
                                        <tr key={index}>
                                            <td className="tit">{item.title}</td>
                                            <td>{getProgramStatus(item)}</td>
                                            <td>
                                                {getProgramPrice(item) !== 0 && iam?.country !== "KR" && `USD `}
                                                {getProgramPrice(item) ? _U.addComma(getProgramPrice(item)) : "Free"}
                                                {getProgramPrice(item) !== 0 && iam?.country === "KR" && ` 원`}
                                            </td>
                                        </tr>
                                    ))}
                                    {cfg?.isUseSpecialDietary === "Y" && (
                                        <tr>
                                            <td className="tit">Special Dietary Requests</td>
                                            <td colSpan={2} style={{ textAlign: "left" }}>
                                                <p>Vegetarian : {data?.vegetarian}</p>
                                                <p>Allergic : {data?.allergic}</p>
                                                <p>Others : {data?.etc}</p>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        <div className="boxTable">
                            <table className="online_reg_step01">
                                <tbody>
                                    <tr>
                                        <td className="total" width="50%">
                                            Grand Total
                                        </td>
                                        <td className="total" width="50%">
                                            {iam?.country !== "KR" && `USD `}
                                            {_U.addComma(data?.totalAmount)}
                                            {iam?.country === "KR" && ` 원`}
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        {isIdCard() && (
                            <>
                                <h5>Upload Your Student ID </h5>

                                <div className="boxgray">
                                    {data?.fileName && (
                                        <div>
                                            <a href={data?.signedUrl} target="_blank">
                                                {data?.fileName}
                                            </a>
                                        </div>
                                    )}
                                </div>
                            </>
                        )}

                        {data?.totalAmount > 0 && (
                            <>
                                <h5>Payment Information </h5>
                                <div className="boxTable">
                                    <table className="online_reg_step01">
                                        <thead>
                                            <tr>
                                                <th colspan="3">Payment Method </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {data?.payType === "CARD" ? (
                                                <tr>
                                                    <td className="tit" width="20%">
                                                        Credit Card
                                                    </td>
                                                    <td className="ta-l" width="80%">
                                                        <label>Credit Card</label>
                                                    </td>
                                                </tr>
                                            ) : (
                                                <tr>
                                                    <td className="tit">Wire Transfer</td>
                                                    <td className="ta-l">
                                                        <label>Wire Transfer</label>
                                                        <p>
                                                            <strong>Bank Information </strong>
                                                        </p>
                                                        {iam?.country === "KR" ? (
                                                            <>
                                                                <table className="miniTable  ">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="tit" width="20%">
                                                                                입금자
                                                                            </td>
                                                                            <td className="ta-l" width="80%">
                                                                                {data?.senderName}
                                                                            </td>
                                                                        </tr>
                                                                        {/* <tr>
                                                                            <td className="tit">Payment Deadline</td>
                                                                            <td className="ta-l">{moment(data?.paymentDeadline).format("MMM DD, YYYY")}</td>
                                                                        </tr> */}
                                                                    </tbody>
                                                                </table>
                                                                {getMemo("WIRE_TRANSFER_KOR", "content")}
                                                            </>
                                                        ) : (
                                                            <>
                                                                <table className="miniTable  ">
                                                                    <tbody>
                                                                        <tr>
                                                                            <td className="tit" width="20%">
                                                                                Sender’s Name
                                                                            </td>
                                                                            <td className="ta-l" width="80%">
                                                                                {data?.senderName}
                                                                            </td>
                                                                        </tr>
                                                                        {/* <tr>
                                                                            <td className="tit">Payment Deadline </td>
                                                                            <td className="ta-l">{moment(data?.paymentDeadline).format("MMM DD, YYYY")}</td>
                                                                        </tr> */}
                                                                    </tbody>
                                                                </table>
                                                                {getMemo("WIRE_TRANSFER", "content")}
                                                            </>
                                                        )}
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        )}

                        <div className="btnArea1">
                            <button className="btn1 btnBlue1" onClick={() => navigate("/registration/regist")}>
                                Modify
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </Fragment>
    );
};
